import { useParams } from 'react-router-dom';

import { AppPollPage } from '~/components/pages/AppPollPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppPollRoute: React.FC = () => {
  const { appId, pollId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  if (!pollId) {
    return <Navigate to={`/apps/${appId}`} />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppPollPage appId={appId} pollId={pollId} />
    </DashboardTemplate>
  );
};
